import { IInput, IInputConfig } from "./Input";
import { SimpleSignal } from "../SimpleSignal";

export class EmptyInput implements IInput
{
	public static defaultConfig:IInputConfig = {};

	public id: string;
	public changeSignal: SimpleSignal;
	public value: string = null;
	public element: HTMLElement;

	constructor(config:IInputConfig)
	{
		this.element = document.createElement("div");
		this.changeSignal = new SimpleSignal();
	}

	public enable()
	{
	}

	public disable()
	{
	}
}